import { Box, Circle, Image } from "@chakra-ui/react";

export default function EmployeesDisplay({ employees = [], extraEmployeesCount, width, maxVisible }) {
    return (
        <Box d='flex' width={`${width}%`} height='100%' justifyContent={['flex-start', 'flex-start', 'flex-start', 'center']} alignItems='center' mb={['3rem', '3rem', '3rem', '0']}>
            <Box d='flex' position='relative' width={['30%', '30%', '30%', '70%']} height='100%' justifyContent={['flex-start', 'flex-start', 'flex-start', 'center']} alignItems='center'>
                {
                  employees.map((employee, idx) =>
                        <Image
                            src={employee}
                            key={idx}
                            width={['80px', '80px', '48px', '48px']}
                            height={['80px', '80px', '48px', '48px']}
                            position='absolute'
                            zIndex={idx + 1}
                            borderRadius='50%'
                            left={idx === 0 ? '0' : `${idx * 17.5}%`}
                        />)
                }
                {extraEmployeesCount > 0 &&

                    <Circle
                        bg='#000000c5'
                        size={['80px', '80px', '48px', '48px']}
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        fontWeight='700'
                        fontSize={['10px', '12px', '16px', '18px']}
                        color='white'
                        position='absolute'
                        zIndex={`${Number(maxVisible) + 1}`}
                        left={`${(maxVisible - 1) * 17.5}%`}
                    >
                        {extraEmployeesCount}+
                    </Circle>
                }
            </Box>
        </Box>
    )
}